import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import bindAll from 'lodash.bindall';
import Modes from '../lib/modes';

import { changeMode } from '../reducers/modes';
import { clearHoveredItem, setHoveredItem } from '../reducers/hover';
import { clearSelectedItems, setSelectedItems } from '../reducers/selected-items';
import { getSelectedLeafItems } from '../helper/selection';

import ReshapeTool from '../helper/selection-tools/reshape-tool';
import ReshapeModeComponent from '../components/reshape-mode/reshape-mode.jsx';

class ReshapeMode extends React.Component {
  constructor(props) {
    super(props);
    bindAll(this, ['activateTool', 'deactivateTool']);
  }
  componentDidMount() {
    if (this.props.isReshapeModeActive) {
      this.activateTool(this.props);
    }
  }
  componentWillReceiveProps(nextProps) {
    if (this.tool && nextProps.hoveredItemId !== this.props.hoveredItemId) {
      this.tool.setPrevHoveredItemId(nextProps.hoveredItemId);
    }

    if (nextProps.isReshapeModeActive && !this.props.isReshapeModeActive) {
      this.activateTool();
    } else if (!nextProps.isReshapeModeActive && this.props.isReshapeModeActive) {
      this.deactivateTool();
    }
  }
  shouldComponentUpdate(nextProps) {
    return nextProps.isReshapeModeActive !== this.props.isReshapeModeActive;
  }
  componentWillUnmount() {
    if (this.tool) {
      this.deactivateTool();
    }
  }
  activateTool() {
    this.tool = new ReshapeTool(
      this.props.setHoveredItem,
      this.props.clearHoveredItem,
      this.props.setSelectedItems,
      this.props.clearSelectedItems,
      this.props.onUpdateImage,
      this.props.switchToTextTool
    );
    this.tool.setPrevHoveredItemId(this.props.hoveredItemId);
    this.tool.activate();
  }
  deactivateTool() {
    this.tool.deactivateTool();
    this.tool.remove();
    this.tool = null;
    this.hitResult = null;
  }
  render() {
    return (
      <ReshapeModeComponent isSelected={this.props.isReshapeModeActive} onMouseDown={this.props.handleMouseDown} />
    );
  }
}

ReshapeMode.propTypes = {
  clearHoveredItem: PropTypes.func.isRequired,
  clearSelectedItems: PropTypes.func.isRequired,
  handleMouseDown: PropTypes.func.isRequired,
  hoveredItemId: PropTypes.number,
  isReshapeModeActive: PropTypes.bool.isRequired,
  onUpdateImage: PropTypes.func.isRequired,
  setHoveredItem: PropTypes.func.isRequired,
  setSelectedItems: PropTypes.func.isRequired,
  switchToTextTool: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  isReshapeModeActive: state.scratchPaint.mode === Modes.RESHAPE,
  hoveredItemId: state.scratchPaint.hoveredItemId
});
const mapDispatchToProps = (dispatch) => ({
  setHoveredItem: (hoveredItemId) => {
    dispatch(setHoveredItem(hoveredItemId));
  },
  clearHoveredItem: () => {
    dispatch(clearHoveredItem());
  },
  clearSelectedItems: () => {
    dispatch(clearSelectedItems());
  },
  setSelectedItems: () => {
    dispatch(setSelectedItems(getSelectedLeafItems(), false /* bitmapMode */));
  },
  handleMouseDown: () => {
    dispatch(changeMode(Modes.RESHAPE));
  },
  switchToTextTool: () => {
    dispatch(changeMode(Modes.TEXT));
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(ReshapeMode);
